import { createReducer } from '../utils/createReducer';
import { setError, setLoading } from '../utils/helpers';
import {
  REQUEST_MEGAPHONE_BANNER,
  REQUEST_MEGAPHONE_BANNER_FAIL,
  REQUEST_MEGAPHONE_BANNER_SUCCESS,
  UPDATE_MEGAPHONE_BANNER,
  UPDATE_MEGAPHONE_BANNER_FAIL,
  UPDATE_MEGAPHONE_BANNER_SUCCESS,
  CREATE_MEGAPHONE_BANNER,
  CREATE_MEGAPHONE_BANNER_FAIL,
  CREATE_MEGAPHONE_BANNER_SUCCESS,
} from '../actionTypes';

const initialState = {
  loading: false,
  error: null,
  ids: [],
  data: {},
};

export const reducer = createReducer(initialState, {
  [REQUEST_MEGAPHONE_BANNER]: setLoading,
  [REQUEST_MEGAPHONE_BANNER_FAIL]: setError,
  [REQUEST_MEGAPHONE_BANNER_SUCCESS]: (state, action) => ({
    ...state, loading: false, errors: null, data: action.payload.data,
  }),

  [UPDATE_MEGAPHONE_BANNER]: setLoading,
  [UPDATE_MEGAPHONE_BANNER_FAIL]: setError,
  [UPDATE_MEGAPHONE_BANNER_SUCCESS]: (state, action) => ({
    ...state, loading: false, errors: null, data: action.payload.data,
  }),

  [CREATE_MEGAPHONE_BANNER]: setLoading,
  [CREATE_MEGAPHONE_BANNER_FAIL]: setError,
  [CREATE_MEGAPHONE_BANNER_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, [action.payload.id]: action.payload },
    ids: state.ids.concat(action.payload.id),
  }),
});
